export const transformToSafeArray = (value: unknown): string[] => {
  if (Array.isArray(value)) {
    return value
  }
  if (typeof value === 'string' && value.trim()) {
    return value.split('\n').filter((line) => line.trim() !== '')
  }
  return []
}

export const hasAboutContent = (description: Record<string, unknown> | null | undefined): boolean =>
  ['about', 'do', 'documentation'].some((key) => transformToSafeArray(description?.[key]).length > 0)
